import { client } from './generated/client.gen';
import { createBoundedMobileFetch } from './mobile';
import type { MobileApiFailureEvidence } from './mobile';

let mobileFailureReporter: ((evidence: MobileApiFailureEvidence) => void) | undefined;

export * from './generated';
export * from './mobile';

export const configureApi = (
  baseUrl: string,
  accessToken?: string,
  options?: { fetch?: typeof globalThis.fetch },
): void => {
  client.setConfig({
    baseUrl,
    ...(options?.fetch ? { fetch: options.fetch } : {}),
    headers: { Authorization: accessToken ? `Bearer ${accessToken}` : null },
  });
};

export const configureMobileApi = (
  baseUrl: string,
  accessToken?: string,
  options?: {
    fetch?: typeof globalThis.fetch;
    timeoutMs?: number;
    onFailure?: (evidence: MobileApiFailureEvidence) => void;
  },
): void => {
  if (options?.onFailure) mobileFailureReporter = options.onFailure;
  client.setConfig({
    baseUrl,
    fetch: createBoundedMobileFetch({
      ...options,
      ...(mobileFailureReporter ? { onFailure: mobileFailureReporter } : {}),
    }),
    headers: { Authorization: accessToken ? `Bearer ${accessToken}` : null },
  });
};
